import Vue from 'vue'
const selectTag = new Vue()
export default selectTag



// WEBPACK FOOTER //
// ./client/events/selectTag.js